import _ from 'lodash';

const validate = values => {
  const errors = { student: { profile_attributes: {} } }

  if(!_.isEmpty(values.student.profile_attributes)) {
    const { first_name, username, password, password_confirmation } = values.student.profile_attributes
    if(!first_name) {
      errors.student.profile_attributes.first_name = 'must be filled out'
    }
    if(!username) {
      errors.student.profile_attributes.username = 'must be filled out'
    }
    if(!password) {
      errors.student.profile_attributes.password = 'must be filled out'
    }
    if(password && password.length < 8) {
      errors.student.profile_attributes.password = 'must be longer than 8 characters'
    }
    if(!password_confirmation) {
      errors.student.profile_attributes.password_confirmation = 'must be filled out'
    }
    if(password && password_confirmation && password !== password_confirmation) {
      errors.student.profile_attributes.password = 'must match each other'
      errors.student.profile_attributes.password_confirmation = 'must match each other'
    }
  }

  if(!values.student.registration_code) {
    errors.student.registration_code = 'must be filled out'
  }

  return errors
}

export default validate;
